import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  get(id) {
    return axios
      .get(adminPath(`/compliance_document_coverages/${id}`))
      .then((response) => an('ComplianceDocumentCoverage', response.data));
  },
  getCoverages(params) {
    return axios.get(adminPath('/compliance_documents/coverages?') + prepareQueryString(params)).then((response) => {
      return {
        coverages: response.data.map((complianceDocumentCoverage) =>
          an('ComplianceDocumentCoverage', complianceDocumentCoverage)
        ),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  getComplianceDocumentCoverages(complianceDocumentId, params) {
    return axios
      .get(adminPath(`/compliance_documents/${complianceDocumentId}/coverages?`) + prepareQueryString(params))
      .then((response) => {
        return {
          coverages: response.data.map((complianceDocumentCoverage) =>
            an('ComplianceDocumentCoverage', complianceDocumentCoverage)
          ),
          total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
        };
      });
  },
  create(complianceDocumentId, data) {
    return axios
      .post(adminPath(`/compliance_documents/${complianceDocumentId}/coverages`), {
        ...data,
      })
      .then((response) => an('ComplianceDocumentCoverage', response.data));
  },
  email(id, data) {
    return axios
      .post(adminPath(`/compliance_documents/${id}/current_coverage/email`), {
        ...data,
      })
      .then((response) => an('ComplianceDocument', response.data));
  },
  getSpreadsheet(params) {
    return axios.get(adminPath('/compliance_documents/coverages.csv?') + prepareQueryString(params), { responseType: 'blob' });
  },
  getComplianceDocumentCoveragesSpreadsheet(params) {
    return axios.get(
      adminPath(`/compliance_documents/${params.complianceDocumentId}/coverages.csv?`) + prepareQueryString(params),
      {
        responseType: 'blob',
      }
    );
  },
};
